import { Texts } from 'texts';

class TextServices {

  private _texts: {
    [key: string]: any;
  };

  constructor(path?: string) {
    this._texts = this.findJson(path);
  }
    
  findJson(path?: string) {
    const textRaw = Texts[path]
    if (!textRaw) throw new Error('Texts not found');
    this._texts = textRaw;
    return textRaw;
  }

  findByText(path: string, defaultValue?: string | JSX.Element) {
    const pathSepated = path.split('/');
    const text = pathSepated.reduce((acc: any, item: string) => {
      if(!acc || !acc[item]) return null;
      return acc[item];
    }, this._texts);
    if (!text) {
      return defaultValue ?? path;
    }
    return text;
  }

}

const textServices = new TextServices(THEME);

export default textServices